import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateChargingStationDialogContentComponent } from './create-charging-station-dialog-content/create-charging-station-dialog-content.component';

@Component({
  selector: 'app-create-user-dialog',
  template: ''
})
export class CreateChargingStationDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    const dialogRef = this.dialog.open(CreateChargingStationDialogContentComponent, { centered: true, backdrop: 'static', size:'lg' });

    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
